import React, { useEffect, useRef, useState } from 'react'
import Checkbox, { sizeMap as checkboxSizeMap } from 'particles/Checkbox'
import { menuItemClasses } from '@mui/material/MenuItem'
import styled from 'particles/themes/styled'
import { BaseMenuItemProps, MenuItemSize } from '.'
import { StyledBaseMenuItem } from './style'
import Tooltip from 'particles/Tooltip'
import IconButton from 'particles/Button/IconButton'

export interface MenuItemProps extends BaseMenuItemProps {
    text: string
}

interface StyledMenuItemProps extends React.ComponentProps<typeof StyledBaseMenuItem> {
    size?: MenuItemSize
}

const StyledMenuItem = styled(StyledBaseMenuItem)<StyledMenuItemProps>`
    &.${menuItemClasses.root} {
        padding: 4px;
        align-self: stretch;
        @media screen and (max-width: 768px) {
            min-height: auto;
        }
        &.${menuItemClasses.focusVisible} {
            border: 3px solid ${({ theme }) => theme.colors.border.actionFocus};
            padding: 1px;
            background-color: transparent;
        }
        .option {
            flex: 1 0 0;
            & .Mui-focusVisible {
                width: inherit;
                height: inherit;
                border: 0;
            }
        }
        .tooltip {
            padding: ${({ size }) => (size === 'm' ? '4px' : '2px')} 0px;
        }
    }
`

const MenuItemCheckbox: React.FC<MenuItemProps> = ({
    text,
    tooltipContext,
    isDisabled,
    size = 's',
    selected = false,
    ...props
}) => {
    const labelRef = useRef<HTMLInputElement>(null)
    // This will be use to calculate alignItems
    const [offsetHeight, setOffsetHeight] = useState(labelRef.current?.offsetHeight)

    useEffect(() => {
        // Minus 8 for the top and bottom padding, please update this if the padding changes
        setOffsetHeight(labelRef.current?.offsetHeight ? labelRef.current?.offsetHeight - 8 : undefined)
    }, [labelRef.current?.offsetHeight])

    return (
        <StyledMenuItem
            {...props}
            disabled={isDisabled}
            disableRipple
            size={size}
            containerHeight={offsetHeight}
            textScale={checkboxSizeMap[size ?? 's'].textScale}
        >
            <Checkbox
                ref={labelRef}
                label={text}
                size={size}
                checkbox={selected ? 'selected' : 'notSelected'}
                isDisabled={isDisabled}
                className="option"
            />
            {isDisabled && (tooltipContext?.label || tooltipContext?.title) && (
                <Tooltip {...tooltipContext} onClick={e => e.stopPropagation()}>
                    <IconButton size="xs" color="neutral" form="icon" icon="question" className="tooltip" />
                </Tooltip>
            )}
        </StyledMenuItem>
    )
}

export default MenuItemCheckbox
